import { makeStyles } from '@griffel/react';

export const useStyles = makeStyles({
  yammerLogo: {
    fill: 'var(--colorBrandForeground1)',
  },
});
